import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Model from 'flarum/common/Model';
import Discussion from 'flarum/common/models/Discussion';
import DiscussionComposer from 'flarum/common/components/DiscussionComposer';
import DiscussionHero from 'flarum/common/components/DiscussionHero';
import CustomFieldsEditor from './components/CustomFieldsEditor';
import CustomFieldsViewer from './components/CustomFieldsViewer';

app.initializers.add('butterflycode-custom-fields', () => {
  Discussion.prototype.customFieldValues = Model.attribute('customFieldValues');
  Discussion.prototype.canViewCustomFields = Model.attribute('canViewCustomFields');
  Discussion.prototype.canEditCustomFields = Model.attribute('canEditCustomFields');

  // Add custom fields to the discussion composer (between title and body)
  extend(DiscussionComposer.prototype, 'headerItems', function (items) {
    const definitions = app.forum.attribute('customFieldDefinitions');
    if (!definitions || !definitions.length) return;

    items.add(
      'custom-fields',
      <CustomFieldsEditor
        definitions={definitions}
        values={this.composer.fields.customFieldValues || {}}
        onchange={(values) => {
          this.composer.fields.customFieldValues = values;
        }}
      />,
      -10
    );
  });

  // Include custom field values in the API request data
  extend(DiscussionComposer.prototype, 'data', function (data) {
    const values = this.composer.fields.customFieldValues;
    if (!values) return;

    data.customFieldValues = values;
  });

  // Display custom fields on the discussion hero (below title)
  extend(DiscussionHero.prototype, 'items', function (items) {
    const discussion = this.attrs.discussion;
    if (!discussion.canViewCustomFields()) return;

    const values = discussion.customFieldValues();
    const hasValues = values && Object.keys(values).length > 0;

    if (!hasValues && !discussion.canEditCustomFields()) return;

    const definitions = app.forum.attribute('customFieldDefinitions');
    if (!definitions || !definitions.length) return;

    items.add(
      'custom-fields',
      <CustomFieldsViewer discussion={discussion} definitions={definitions} />,
      -20
    );
  });
});
